module.exports = __webpack_public_path__ + "static/media/pdf_banner.3a0d62d1.png";